import Heading from "Components/Heading";
import React, { useEffect, useMemo, useState } from "react";
import { Card, Form } from "react-bootstrap";
import Footer from "Components/Footer";
import Loader from "Components/Loader";
import TicketAPIs from "../../APIs/ticket";
import SampleDataTable from "Components/DataTables";
import UserTicketDetail from "./components/UserTicketDetails";

const OutstandingTickets = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchedData, setSearchedData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [selectedUserID, setSelectedUserID] = useState(null);
  const [selectedTab, setSelectedTab] = useState("tab1");

  //  NEW: search state
  const [searchText, setSearchText] = useState("");

  const getTicketOutstanding = async () => {
    setIsLoading(true);
    const res = await TicketAPIs.ticketOutstanding();
    if (res && Array.isArray(res.data.data)) {
      const sortedData = res.data.data.sort((a, b) =>
        (a.username || "").localeCompare(b.username || ""),
      );
      setSearchedData(sortedData);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    setUsers(user);
    getTicketOutstanding();
  }, []);

  const columns = [
    {
      accessor: "username",
      Header: "User",
      Cell: ({ row }) => (
        <p>
          <a
            href="#!"
            onClick={(e) => {
              setSelectedUserID(row.original.userId);
              e.preventDefault();
              setModalShow(true);
            }}
            rel="noopener noreferrer"
            style={{ marginRight: 10 }}
          >
            {row.original.username}
          </a>
          {"("}
          <a
            href="#"
            onClick={(e) => {
              setSelectedUserID(row.original.userId);
              setSelectedTab("tab1");
              e.preventDefault();
              setModalShow(true);
            }}
            rel="noopener noreferrer"
          >
            show map
          </a>
          {") ("}
          <a
            href="#"
            onClick={(e) => {
              setSelectedUserID(row.original.userId);
              setSelectedTab("tab2");
              e.preventDefault();
              setModalShow(true);
            }}
            rel="noopener noreferrer"
          >
            show ticket
          </a>
          {")"}
        </p>
      ),
    },
    { accessor: "assignedCount", Header: "Assigned" },
    {
      accessor: "preCompletedCount",
      Header: "Pre-Completed",
      Cell: ({ value }) => <p style={{ textAlign: "left" }}>{value}</p>,
    },
  ];



  const filteredData = useMemo(() => {
    // default base data = only assignedCount > 0
    const baseData = searchedData.filter(
      (r) => Number(r?.assignedCount || 0) > 0,
    );

    // apply search on top of that baseData
    const q = searchText.trim().toLowerCase();
    if (!q) return baseData;

    // (optional) keep this special keyword, but now it's redundant because base is already assigned>0
    if (q === "assigned" || q === "assigned>0" || q === "assigned > 0") {
      return baseData;
    }

    return baseData.filter((r) => {
      const username = (r?.username || "").toLowerCase();
      const assignedStr = String(r?.assignedCount ?? "").toLowerCase();
      const preCompletedStr = String(r?.preCompletedCount ?? "").toLowerCase();

      const haystack = `${username} ${assignedStr} ${preCompletedStr}`;
      return haystack.includes(q);
    });
  }, [searchedData, searchText]);

  return (
    <>
      {isLoading ? (
        <Loader isLoading={isLoading} />
      ) : (
        <section>
          <Heading text={"Outstanding Tickets"} />
          <Card style={{ padding: "16px" }}>
            {/*  NEW: Search field */}
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ maxWidth: 520, marginBottom: 12 }}
            />

            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "100%", maxWidth: 1200 }}>
                <SampleDataTable
                  columns={columns}
                  data={filteredData}
                  resultsTitle={"Total Users Found"}
                />
              </div>
            </div>

            <UserTicketDetail
              show={modalShow}
              onHide={() => setModalShow(false)}
              userId={selectedUserID}
              selectedTab={selectedTab}
            />
            <Footer />
          </Card>
        </section>
      )}
    </>
  );
};

export default OutstandingTickets;
